// Zod-free on purpose: the locale and audience lists are read on every page (I18nProvider,
// the audience store), and importing zod here would put it on each page's critical path.
export const LOCALES = ["it", "en"] as const;
export type Locale = (typeof LOCALES)[number];

export const AUDIENCES = ["companies", "producers"] as const;
export type Audience = (typeof AUDIENCES)[number];

export type ConsentChoice = "granted" | "denied";

export type VpSlug =
  | "riduzione-prevedibile"
  | "conformita"
  | "ebitda"
  | "copertura-naturale"
  | "impatto";

export type RoleSlug = "ipp-light" | "ipp" | "utility";

export type Tint = "green" | "blue";
